export enum ColumnsOptionsOpenedOrdersEnum {
	tickerCompany = 'tickerCompany',
	orderType = 'orderType',
	quantity = 'quantity',
	operation = 'operation',
	price = 'price',
	term = 'term',
	statusTitle = 'statusTitle',
}
